<template>
  <div v-if="dataPermission.includes('CNPS_DEVICE_ORDER_TRANSFER_VIEW')">
    <div v-if="item">
      <div class="breadcrumb-area pos-relative w-100">
        <h1>Chi tiết phiếu điều chuyển</h1>
        <div class="btn-group float-right">
          <button
            type="button"
            class="font-medium btn btn-outline-secondary"
            @click="$router.push('/transfer-agency')"
          >
            <i class="bx bx-exit"></i> Quay lại
          </button>
          <button
            class="btn font-medium btn-outline-secondary"
            v-if="canApproveGeneral(item.status, item.managerIdInventory)"
            @click="approveGenerateItem(item)"
          >
            <i class="bx bx-check-circle"></i><span>&nbsp;</span>Sinh phiếu đặt hàng
          </button>
          <button class="f12 font-medium btn btn-outline-secondary" @click="exportExcel()">
            <i class="bx bx-download"></i> Xuất excel
          </button>
          <button class="btn font-medium btn-outline-secondary" @click="inTicket(item.id)">
            <i class="bx bx-copy"></i><span>&nbsp;</span>In phiếu
          </button>
          <button
            v-if="canReject(item.status, item.managerIdInventory)"
            class="btn font-medium btn-outline-secondary"
            @click="rejectItem(item)"
          >
            <i class="bx bx-copy"></i><span>&nbsp;</span>Tạo phiếu đặt hàng
          </button>
          <button
            class="btn font-medium btn-outline-secondary"
            v-if="canEdit(item.status, item.userCreator)"
            @click="editItem(item.id)"
          >
            <i class="bx bx-pencil"></i><span>&nbsp;</span>Sửa
          </button>
          <button
            class="btn font-medium btn-outline-secondary"
            v-if="canApprove(item.status, item.managerIdInventory)"
            @click="approveItem(item)"
          >
            <i class="bx bx-check-circle"></i><span>&nbsp;</span>Duyệt
          </button>
          <button
            v-if="canReject(item.status, item.managerIdInventory)"
            class="btn font-medium btn-outline-secondary"
            @click="rejectItem(item)"
          >
            <i class="bx bx-x-circle"></i><span>&nbsp;</span>Từ chối
          </button>
          <button
            v-if="canCancel(item.status, item.userCreator, item.managerIdInventory)"
            class="btn font-medium btn-outline-secondary"
            @click="cancelItem(item)"
          >
            <i class="bx bxs-trash"></i><span>&nbsp;</span>Huỷ
          </button>
          <button
            v-if="canApproveExport(item, item.userCreator)"
            class="btn font-medium btn-outline-secondary"
            @click="approveExport(item.id)"
          >
            <i class="bx bx-check-circle"></i><span>&nbsp;</span>Xác nhận đã chuyển
          </button>
          <button
            v-if="canApproveImport(item.status, item.keeperIdConfirmImport)"
            class="btn font-medium btn-outline-secondary"
            @click="approveImport(item.id)"
          >
            <i class="bx bx-check-circle"></i><span>&nbsp;</span>Xác nhận đã nhận
          </button>
          <!-- <button
            v-if="canRejectImport(item.status, item.keeperIdConfirmImport)"
            class="btn font-medium btn-outline-secondary"
            @click="rejectImport(item)"
          >
            <i class="bx bx-x-circle"></i><span>&nbsp;</span>Không nhận được hàng
          </button> -->
          <button
            v-if="canCancelMoving(item.status, item.keeperIdConfirmImport)"
            class="btn font-medium btn-outline-secondary"
            @click="cancelMovingCancel = true"
          >
            Từ chối nhận hàng
          </button>
          <button
            v-if="canCoppy(item.status, item.userCreator)"
            class="btn font-medium btn-outline-secondary"
            @click="copyItem(item.id)"
          >
            <i class="bx bx-copy"></i><span>&nbsp;</span>Tạo bản copy
          </button>
        </div>
      </div>
      <div class="card p-10 pt-15 b-t-1-869fb229">
        <div class="form-row">
          <div class="col-md-6">
            <div class="form-detail">
              <h1 class="form-inner-heading mb-1">Thông tin</h1>
              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label">
                  Số phiếu <span class="float-right">:</span>
                </label>
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">
                    {{ item.billNumber }}
                  </p>
                </div>
              </div>
              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label">
                  Tên kho chuyển<span class="float-right">:</span>
                </label>
                <div class="col-sm-8">
                  <p
                    class="form-control-plaintext f12 text-primary"
                    type="button"
                    @click="$router.push(`/cat-warehouse/${item.inventoryIdExport}`)"
                  >
                    {{ item.inventoryNameExport }}
                  </p>
                </div>
              </div>
              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label">
                  Tên kho nhận<span class="float-right">:</span>
                </label>
                <div class="col-sm-8">
                  <p
                    class="form-control-plaintext f12 text-primary"
                    type="button"
                    @click="$router.push(`/cat-warehouse/${item.inventoryIdImport}`)"
                  >
                    {{ item.inventoryNameImport }}
                  </p>
                </div>
              </div>
              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label">
                  Trạng thái<span class="float-right">:</span>
                </label>
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">
                    <span class="badge" :class="[item.status || '']">
                      {{ item.status | transformData(Config.statusWarehouse) }}
                    </span>
                  </p>
                </div>
              </div>

              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label">
                  Lý do điều chuyển<span class="float-right">:</span>
                </label>
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">
                    {{ item.reasonTransfer | transformData(Config.reasonTransferWarehouse) }}
                  </p>
                </div>
              </div>

              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label">
                  Ngày chuyển<span class="float-right">:</span>
                </label>
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">
                    {{ item.timeExport | formatDate('HH:mm, DD/MM/YYYY') }}
                  </p>
                </div>
              </div>

              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label">
                  Ngày tạo<span class="float-right">:</span>
                </label>
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">
                    {{ item.dateCreate | formatDate('HH:mm, DD/MM/YYYY') }}
                  </p>
                </div>
              </div>

              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label">
                  Người tạo<span class="float-right">:</span>
                </label>
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">
                    {{ item.userCreator.name }} - {{ item.userCreator.email }}
                  </p>
                </div>
              </div>

              <div class="form-group form-row">
                <label for="" class="col-sm-4 col-form-label">
                  Ghi chú<span class="float-right">:</span>
                </label>
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">
                    {{ item.description }}
                  </p>
                </div>
              </div>

              <div
                class="form-group form-row"
                v-if="['APPROVED', 'REJECTED', 'CANCELLED'].includes(item.status)"
              >
                <label for="" class="col-sm-4 col-form-label">
                  Thời gian {{ getPersonAction(item.status) }}
                  <span class="float-right">:</span>
                </label>
                <div class="col-sm-8">
                  <p v-if="item.status === 'APPROVED'" class="form-control-plaintext f12">
                    {{ item.timeApprove | formatDate('HH:mm, DD/MM/YYYY') }}
                  </p>
                  <p v-if="item.status === 'REJECTED'" class="form-control-plaintext f12">
                    {{ item.timeReject | formatDate('HH:mm, DD/MM/YYYY') }}
                  </p>
                  <p v-if="item.status === 'CANCELLED'" class="form-control-plaintext f12">
                    {{ item.timeCancel | formatDate('HH:mm, DD/MM/YYYY') }}
                  </p>
                </div>
              </div>

              <div
                class="form-group form-row"
                v-if="['APPROVED', 'REJECTED', 'CANCELLED'].includes(item.status)"
              >
                <label for="" class="col-sm-4 col-form-label">
                  Người {{ getPersonAction(item.status) }}
                  <span class="float-right">:</span>
                </label>
                <div class="col-sm-8">
                  <p v-if="item.status === 'APPROVED'" class="form-control-plaintext f12">
                    {{ item.personApprove.name }} - {{ item.personApprove.email }}
                  </p>
                  <p v-if="item.status === 'REJECTED'" class="form-control-plaintext f12">
                    {{ item.personReject.name }} - {{ item.personReject.email }}
                  </p>
                  <p v-if="item.status === 'CANCELLED'" class="form-control-plaintext f12">
                    {{ item.personCancel.name }} - {{ item.personCancel.email }}
                  </p>
                </div>
              </div>

              <div class="form-group form-row" v-if="item.status === 'REJECTED'">
                <label for="" class="col-sm-4 col-form-label">
                  Lý do từ chối<span class="float-right">:</span>
                </label>
                <div class="col-sm-8">
                  <p class="form-control-plaintext f12">
                    {{ item.reasonReject }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="form-detail">
              <h1 class="form-inner-heading mb-1">Lịch sử xác nhận điều chuyển</h1>
              <div class="table-responsive">
                <table
                  class="table table-hover table-bordered"
                  style="max-height: 400px; overflow-y: auto"
                >
                  <thead class="thead-light">
                    <tr>
                      <th scope="col" class="text-center">Thời gian</th>
                      <th scope="col" class="text-center">Loại</th>
                      <th scope="col" class="text-center">Người xác nhận</th>
                      <th scope="col" class="text-center">Tổng số TB</th>
                      <th scope="col" class="text-center">Chi tiết</th>
                      <th scope="col" class="text-center">Lý do từ chối nhập TB</th>
                      <th scope="col" class="text-center">Ghi chú</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr class="table-row" v-for="(s, index) in item.orderHistories" :key="index">
                      <td class="text-center">
                        {{ s.dateCreate | formatDate('HH:mm DD/MM/YYYY') }}
                      </td>
                      <td class="text-center">
                        {{ s.status | transformData(Config.historyWarehouse) }}
                      </td>
                      <td class="text-center">
                        {{ s.userApprove && s.userApprove.name }} -
                        {{ s.userApprove && s.userApprove.email }}
                      </td>
                      <td class="text-center">
                        {{ s.quantity }}
                      </td>
                      <td class="text-center">
                        <a
                          href="#"
                          @click="historyDetail(item.id, s)"
                          v-if="['MOVING', 'SUCCESS'].includes(s.status)"
                          to="/"
                          >Chi tiết</a
                        >
                      </td>
                      <td class="text-center">
                        {{ s.status === 'REJECT_IMPORT' ? item.reasonRejectImport : null }}
                      </td>
                      <td class="text-center">
                        {{ s.noteExport }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div class="card pt-2 p-10">
          <div class="d-flex pos-relative w-100 justify-content-between mb-2">
            <h1 class="form-inner-heading mb-1">Bảng thông tin thiết bị</h1>
          </div>
          <div class="box-header">
            Tổng:
            <strong class="text-primary">{{ item.quantityExport }}</strong>
          </div>
          <div class="tab-content">
            <div
              class="table-responsive b-table-sticky-header"
              style="overflow: auto; max-height: 70vh"
            >
              <table class="table table-hover table-bordered">
                <thead class="thead-light">
                  <tr class="text-center">
                    <th>Tên thiết bị</th>
                    <th>Số lượng</th>
                    <th>Mã Serial</th>
                    <th>Đơn vị tính</th>
                    <th>Tình trạng</th>
                    <th>Ghi chú</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    class="table-row text-center"
                    v-for="(device, index) in item.devices"
                    :key="`device${index}`"
                  >
                    <td>{{ device.categoryName }}</td>
                    <td>{{ device.quantity }}</td>
                    <td>{{ device.serial }}</td>
                    <td>{{ device.unit | transformData(Config.unitDevice) }}</td>
                    <td>
                      <span class="badge" :class="[device.type || '']">
                        {{ device.type | transformData(Config.stateDevices) }}
                      </span>
                    </td>
                    <td>{{ device.noteExport }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div v-if="notiModal">
        <transition name="modal">
          <div class="modal-mask">
            <div class="modal-wrapper">
              <div class="modal-dialog">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">Thông báo</h5>
                    <button
                      type="button"
                      class="close"
                      data-dismiss="modal"
                      @click="notiModal = false"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div class="modal-body text-center">
                    <img :src="iconNoti" alt="icon-successs" />
                    <h2 class="f18 py-3">{{ msgNoti }}</h2>
                  </div>
                  <div class="modal-footer">
                    <button
                      type="button"
                      class="btn btn-primary"
                      @click="checkToActionModal(keyCheck)"
                      data-dismiss="modal"
                      v-if="keyCheck === 'accept' || keyCheck === 'back' || keyCheck === 'addLead'"
                    >
                      Đồng ý
                    </button>
                    <button
                      type="button"
                      class="btn btn-light"
                      @click="notiModal = false"
                      data-dismiss="modal"
                      v-if="keyCheck === 'cancel' || keyCheck === 'back'"
                    >
                      Bỏ qua
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </transition>
      </div>
    </div>
    <b-modal centered static hide-footer hide-header size="xl" id="historyDetail">
      <detail-approve
        v-if="devicesHistory"
        :devices="devicesHistory"
        :item="item"
        :warehouseData="warehouseData"
      ></detail-approve>
    </b-modal>

    <b-modal id="cancel-moving" centered v-model="cancelMovingCancel">
      <template #modal-header="{ close }">
        <h5>Lý do từ chối</h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          @click="close(), (reasonReject = '')"
          aria-label="Close"
        >
          <span aria-hidden="true">&times;</span>
        </button>
      </template>
      <ValidationObserver>
        <ValidationProvider rules="required|minMaxName_1" vid="reasonReject" name="Lý do từ chối">
          <div slot-scope="{ errors }">
            <div class="text-center m-2">
              <input v-model="reasonReject" />
              <p class="text-danger">{{ errors[0] }}</p>
            </div>
          </div>
        </ValidationProvider>
      </ValidationObserver>
      <template #modal-footer="{ cancel }">
        <b-button variant="light" @click="cancel(), (reasonReject = '')"> Đóng </b-button>
        <b-button
          variant="primary"
          @click="cancelMoving(item, reasonReject), (cancelMovingCancel = false)"
          :disabled="reasonReject == ''"
        >
          Đồng ý
        </b-button>
      </template>
    </b-modal>
    <VueLoadingOverlay :active.sync="loading" :is-full-page="true"> </VueLoadingOverlay>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { DeviceService } from '@/services/device.service'
  import Config from '@/thirdParty/config'
  import mxItemAction from './mx-item-action.js'
  import detailApprove from './detail-approve.vue'
  export default {
    mixins: [mxItemAction],
    components: { detailApprove },
    data() {
      return {
        devicesHistory: null,
        item: null,
        entryId: this.$route.params.entryId,
        dataUser: JSON.parse(localStorage.getItem('userData')),
        loading: false,
        notiModal: false,
        msgNoti: '',
        iconNoti: '',
        Config,
        warehouseData: [],
        cancelMovingCancel: false,
        reasonReject: '',
      }
    },
    filters: {
      transformData(data, dataConfig) {
        const dataReturn = dataConfig?.find(e => e.id === data) ?? {}
        return dataReturn.text || data
      },
    },
    mounted() {
      this.$root.$on('bv::modal::hide', bvEvent => {
        if (bvEvent.trigger === 'ok' && this.$refs.rejectValue) {
          if (!this.$refs.rejectValue.value.trim()) {
            this.showErr('Lý do điều chuyển không được bỏ trống')
            bvEvent.preventDefault()
          } else if (
            this.$refs.rejectValue.value.trim().length < 2 ||
            this.$refs.rejectValue.value.trim().length > 255
          ) {
            this.showErr('Lý do điều chuyển ký tự nhỏ nhất là 2 và lớn nhất là 255 ký tự')
            bvEvent.preventDefault()
          }
        }
      })
    },
    created() {
      this.fetchWarehouse()
      this.fetchData()
    },

    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
    },

    methods: {
      async historyDetail(id, historyDevice) {
        try {
          this.loading = true
          const response = await DeviceService.detailHistoryTransferWarehouse({
            id,
            status: historyDevice.status,
          })
          if (response.code === 1000 || response.success) {
            this.devicesHistory = response.data
            this.item.historyDeviceCreate = historyDevice.dateCreate
            this.item.historyDeviceStatus = historyDevice.status
            this.$bvModal.show('historyDetail')
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.loading = false
        }
      },
      async fetchData() {
        try {
          this.loading = true
          const response = await DeviceService.detailTransferWarehouse(this.entryId)
          if (response.code === 1000 || response.success) {
            this.item = response.data
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.loading = false
        }
      },
      async fetchWarehouse() {
        const response = await DeviceService.getListSearchWarehouse()
        this.warehouseData = response.data.map(({ id, name }) => {
          return { id, text: name }
        })
      },
      showErr(message) {
        this.notiModal = true
        this.iconNoti = require('@/assets/img/noti-unsuccess2.svg')
        this.msgNoti = message
      },
      showSuccess(message) {
        this.notiModal = true
        this.iconNoti = require('@/assets/img/noti-success2.svg')
        this.msgNoti = message
      },
      getPersonAction(status) {
        if (status === 'APPROVED') return 'duyệt'
        if (status === 'REJECTED') return 'từ chối'
        return 'huỷ'
      },
      async exportExcel() {
        try {
          this.loading = true
          const req = {
            id: this.entryId,
          }
          await DeviceService.exportExcelTransferWarehouseDetail(req, this.item.billNumber)
        } catch (error) {
          console.log(error)
        } finally {
          this.loading = false
        }
      },
    },
  }
</script>
